import axios from 'axios'
import _ from 'lodash'
import { getStore, keys } from '../store'
import router from '../router'

// const baseUrl = 'https://classover2.ysdftech.com'
const baseUrl = 'https://app.classover.com'


export default function request(config) {
    return new Promise((resolve, reject) => {
        let token = getStore(keys.token)
        // let lang = getStore(keys.lang) || 'zh_CN'
        let lang=  'zh_CN'
        if (token)
            token = `Bearer ${token}`
        axios(_.merge(config, {
            url: baseUrl + config.url,
            headers: {
                Authorization: token,
                lan: lang
            }
        })).then((data) => {
            if (data.data.code == 200)
                resolve(data.data.data)
            else if ([10001, 10002, 10003].includes(data.data.code)) {
                router.push({ path: '/' })
            }
            else {
                reject(data.data)
                alert(data.data.msg)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export function get(url, data) {
    return request({
        url: url,
        method: 'get',
        data: data
    })
}

export function post(url, data) {
    return request({
        url: url,
        method: 'post',
        data: data
    })
}

export function put(url, data) {
    return request({
        url: url,
        method: 'put',
        data: data
    })
}

export function remove(url, data) {
    return request({
        url: url,
        method: 'delete',
        data: data
    })
}



// WEBPACK FOOTER //
// ./src/api/request.js